import { render, staticRenderFns } from "./OrderSendDialog.vue?vue&type=template&id=1c3d953d&scoped=true"
import script from "./OrderSendDialog.vue?vue&type=script&lang=js"
export * from "./OrderSendDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderSendDialog.vue?vue&type=style&index=0&id=1c3d953d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3d953d",
  null
  
)

export default component.exports